Vue.component('request-email-history-chat', {
	props: ['options','labellang'],
	template:	'<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">'+
					'<div id="request-email-history-chat">'+
						'<div class="overlay-content">'+
						'	<form @submit.prevent="sendForm">'+
										'<button type="button" @click="closeView" class="close" aria-label="Close">'+
											'<span aria-hidden="true">&times;</span>'+
										'</button>'+
											'<p v-if="hasTitleClose" class="titleBye"> {{ text.titleClose }} </p>'+
											'<h3> {{ text.title }} </h3>'+
											'<div class="input-group offset-top-40">'+
												'<span class="input-group-addon">@</span>'+
												'<input type="email" required="required"  class="form-control" :placeholder="text.placeholder" aria-describedby="email-input" @blur="ifEmail(email)" v-model="email">'+
											'</div>'+
											'<p class="alert-danger text-center offset-top-10">{{ this.msgError }}</p>'+
							'</div>'+
							'<div class="overlay-footer">'+
								'<button @click="closeView" class="btn pull-left" data-language="cancel" data-language-type="text"> {{ text.btn.cancel }} </button>'+
								'<button @click.prevent="sendForm"   class="btn btn-info pull-right"  data-language="send" :disabled="isSendDisable" data-language-type="text" >{{ text.btn.send }}</button>'+
							'</div>'+
						'</form>'+
					'</div>'+
				'</transition>',
	data:function(){
		return {
			isActive:false,
			isSendDisable:false,
			email:'',
			formValid:false,
			hasTitleClose:false,
			msgError:'',
			text: {
				title: this.labellang.chatHistoryMessage,
				titleClose:null,
				placeholder: this.labellang.chatHistoryPlaceholder,
				btn: {
					send: this.labellang.webcb_send_button,
					cancel: this.labellang.cancel
				}
			}
		}
	},
	mounted: function() {
		var that = this;
		bus.$on('onReserveEmail', function (val) {
			that.contentShow(val);
		})

		this.$parent.$on('onReserveEmail', function (val) {
			that.contentShow(val);
		})

		bus.$on('onMsgClose', function (val) {
			that.setTitleClose(val);
		})

	},
	methods:{
			contentShow:function(val){
				this.isActive = val;
			},
			isEmail: function(value) {
				var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(value);
			},
			ifEmail:function(){
				this.msgError = ''
				if( this.email.length >=1 ){
					var isValid =  this.isEmail(this.email);
					if( isValid  ){
						this.msgError = ''
						this.formValid = true;
						return true;
					}else{
						this.msgError = this.labellang.emailNotValid;
						this.formValid = false;
						return false;
					}
				}
			},
			closeView:function(){
				this.isActive = false;
				if(!this.options.internal.endChat && !this.options.inPause){
					bus.$emit("onResumeChat", false);
				};
			},
			setTitleClose:function(val){
				this.hasTitleClose = true;
				this.text.titleClose = val;

			},
			sendForm:function(){
				if( this.formValid ){
					this.options.internal.bridge.reserveEmailChatHistory(this.email);
					this.$parent.appendSystemMsg(null, this.labellang.emailReservedImminent)
					this.email = '';
					this.isActive = false;
					if(this.options.internal.endChat){
						bus.$emit("onResumeChat", true);
					}else{
						bus.$emit("onResumeChat", false);
					}
				}else {
					return false;
				}

			}
	},
})
